/* eslint-disable @typescript-eslint/naming-convention */
export const PrimaryImageAngle = 'hero'

export const PrimaryImageFieldName = 'primaryImageUrl'

export type SecondaryImageAnglesType =
  | 'angle_left'
  | 'angle_right'
  | 'angle_back'
  | 'angle_top'
  | 'ingredients'
  | 'nutrition'
  | 'supplements'
  | 'drugs'
  | 'lifestyle'

export const SecondaryImageAngles = [
  'angle_left',
  'angle_right',
  'angle_back',
  'angle_top',
  'ingredients',
  'nutrition',
  'supplements',
  'drugs',
  'lifestyle',
]

export type SecondaryImageValue = {
  imageType: string
  imageUrl: string
}

export type SecondaryImageAngleMapping = { [key in SecondaryImageAnglesType]: string | undefined }

export const SecondaryImageDefaults: SecondaryImageAngleMapping = {
  angle_left: undefined,
  angle_right: undefined,
  angle_back: undefined,
  angle_top: undefined,
  ingredients: undefined,
  nutrition: undefined,
  supplements: undefined,
  drugs: undefined,
  lifestyle: undefined,
}

export type EditImagesValues = {
  primaryImageUrl: string | undefined
  secondaryImages: SecondaryImageAngleMapping
}

export type EditImagesErrors = {
  primaryImageUrl: string | undefined
  secondaryImages: {}
}

export type SecondaryImagesRequest = {
  angle: string
  primary_url: string
}

export type ImageUpdateRequest = {
  product_image: {
    remote_image_url: string
  }
  secondary_images: SecondaryImagesRequest[]
}
